<template>
	<div class="component comments-modal modal">
		
		<div class="uk-flex uk-flex-middle uk-flex-center" @click="open()">
			<span :class="{ 'uk-navbar-item uk-padding-small' : navBarItem }">
				<span class="icon material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z"/></svg></span>
				<span class="total-comments">{{ totalComments }}</span>
				<span class="uk-visible@m uk-padding-xsmall-left" v-show="showLabel">reactie<span v-show="totalComments != 1">s</span></span>
			</span>
		</div>
	
		<VueSidePanel
				v-model="sidePanel"
				:lock-scroll="false"
				side="right"
				width="800px"
				:hide-close-btn="true"
			>
				<template #header>
					<div class="side-panel-header uk-padding-small">
						<div class="uk-grid uk-grid-collapse uk-flex uk-flex-middle">
							<div class="uk-width-auto">
								<h4 class="uk-margin-remove icon"><span class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-400h480v-80H240v80Zm0-120h480v-80H240v80Zm0-120h480v-80H240v80ZM880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46 45v-525H160v480Zm0 0v-480 480Z"/></svg></span></h4>
							</div>
							<div class="uk-width-expand uk-relative">
								<h4 class="text">Reacties</h4>
							</div>
							<div class="uk-width-auto uk-text-right">
								<a href="javascript:void(0)" class="uk-icon-button" style="background: transparent" @click="close" uk-icon="close"></a>
							</div>
						</div>
					</div>
				</template>
					<template #default>
				 <div class="uk-padding uk-text-left" style="padding-bottom: 80px">
					 <comments-loader 
						 v-if="sidePanel"
						 :url="url"
						 :js-variables="jsVariables" 
						 :auto-load="true"
					 ></comments-loader>
				 </div>				 
				 </template>
				<template #footer>
					<a href="javascript:void(0)" class="uk-icon-button" style="background: transparent" @click="close" uk-icon="close"></a>
				</template>			 
				 
		</VueSidePanel>
				 
	</div>
</template>

<script setup lang="ts">

// Swiper
import swipeModal from '@takuma-ru/vue-swipe-modal';
import { ref, onMounted, onBeforeMount } from 'vue';
import axios from 'axios';

// Own components
import LoadingIndicator from './LoadingIndicator.vue'
import CommentsLoader from './CommentsLoader.vue'

// Refs
const bottomModal = ref(false);
const sidePanel = ref(false);
const isLoading = ref(true);
const modalContent = ref('');
const localContentsWidth = ref<string>('');

// Helper 
import helper from '../js/helper';

// Open
const open = () => {

	if(props.nativeModal) {
		// Open native model in app, so send and event 
		helper.sendAppMessage({
			action: 'showCommentsModal',
			elementId: props.jsVariables.settings.element.id
		})
	}	else {
		
		// default side panel (web)
		sidePanel.value = true;
	}
};

// Close
const close = () => {
	sidePanel.value = false;
};

// Opened
const opened = () => {
	//console.log('opened!');
};

// Props
const props = defineProps({
	totalComments: {
		type: Number,
		required: false
	},
	url: {
		type: String,
		required: true
	},
	jsVariables: {
		type: Object,
		required: true
	},
	contentsWidth: {
		type: String
	},
	navBarItem: {
		type: Boolean,
		required: false,
		default: false
	},
	showLabel: {
		type: Boolean,
		required: false,
		default: true
	},
	nativeModal: {
		type: Boolean,
		required: false,
		default: false		
	},
});

// Load content
const loadContent = async () => {
	
	console.log('app/components/comments-loader/loadContent');
	
	if(!props.elementId) return;

	try {
		const response = await axios.get('/async/comments?id=' + props.elementId + '&notificationSubscribeEnabled=' + props.notificationSubscribeEnabled);
		modalContent.value = response.data;
		isLoading.value = false;
	} catch (error) {
		console.error('Error loading remote URL:', error);
		isLoading.value = false;
	}
}
// On Mounted
onMounted(async () => {
});

// Before Mount
onBeforeMount(() => {
	
		// Set modal width for desktop vs mobile
		const viewportWidth = window.innerWidth;
		const breakpoint = 768;

		if (viewportWidth > breakpoint) {
				localContentsWidth.value = "80%";
		} else {			
				localContentsWidth.value = "100%";
		}
});

</script>

<style scoped>	
	
.component.comments-modal {
}
.component.comments-modal:hover .icon {
	color: var(--tint-color);
}
.component.comments-modal:hover svg {
	fill: var(--tint-color);
}
.component.comments-modal .total-comments {
	font-size: 1.2rem;
	padding-left: 2px;
}

/* header */
.side-panel-header { 
	background: #20202C;
}
.side-panel-header .icon,
.site-panel-header svg {
	color: #f4f4f4;
	fill: #f4f4f4;
}
.side-panel-header .text {
	color: #f4f4f4;
	margin-left: 15px;
}

/* dark mode */
body.dark #vsp-container > div.vsp-wrapper.vsp-wrapper--active > div.vsp.vsp--right-side {
	background: blue !important;
}
body.dark .vsp.vsp--right-side {
	background: red !important;
}
</style>
